<div class="card">
  <app-header
    [titulo]="'Wizard de Configuração: ' + (processo?.nome || '')"
    descricao="Configure o fluxo completo de recursos para este processo.">
  </app-header>

  <p-steps [model]="steps" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

  <div class="wizard-content mt-4">
    <!-- Passo 1: Importação -->
    <div *ngIf="activeIndex === 0">
      <p-panel header="Passo 1: Configurar Recurso de Importação">
        <form [formGroup]="formImportacao">
          <div class="grid p-fluid mt-2">
            <!-- Seção Recurso -->
            <div class="col-12">
              <h5 class="border-bottom-1 surface-border pb-2">Dados do Recurso</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeRecurso" formControlName="nomeRecurso" [class.ng-invalid]="campoInvalido('nomeRecurso', 0)" />
                <label for="nomeRecurso">Nome do Recurso *</label>
              </p-floatLabel>
              <small class="p-error" *ngIf="campoInvalido('nomeRecurso', 0)">Nome do recurso é obrigatório.</small>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="descricaoRecurso" formControlName="descricaoRecurso" />
                <label for="descricaoRecurso">Descrição do Recurso</label>
              </p-floatLabel>
            </div>

            <!-- Seção Comando -->
            <div class="col-12 mt-3">
              <h5 class="border-bottom-1 surface-border pb-2">Configuração do Comando de Importação</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeComando" formControlName="nomeComando" [class.ng-invalid]="campoInvalido('nomeComando', 0)" />
                <label for="nomeComando">Nome do Comando *</label>
              </p-floatLabel>
              <small class="p-error" *ngIf="campoInvalido('nomeComando', 0)">Nome do comando é obrigatório.</small>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <p-dropdown 
                  id="tipoComando" 
                  [options]="tiposComando" 
                  formControlName="tipoComando" 
                  placeholder="Selecione o Tipo"
                  appendTo="body">
                </p-dropdown>
                <label for="tipoComando">Tipo de Comando *</label>
              </p-floatLabel>
            </div>

            <!-- Seleção de Provedor e Conexão -->
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <p-dropdown 
                  id="provedorId" 
                  [options]="getProvedoresFiltrados()" 
                  optionLabel="nome" 
                  optionValue="id" 
                  formControlName="provedorId" 
                  [filter]="true" 
                  placeholder="Selecione o Provedor"
                  appendTo="body"
                  [class.ng-invalid]="campoInvalido('provedorId', 0)">
                </p-dropdown>
                <label for="provedorId">Provedor *</label>
              </p-floatLabel>
              <small class="p-error" *ngIf="campoInvalido('provedorId', 0)">Provedor é obrigatório.</small>
            </div>

            <div class="field col-12 md:col-6" *ngIf="formImportacao.get('provedorId')?.value">
              <app-seletor-conexao 
                [provedorId]="formImportacao.get('provedorId')?.value" 
                [conexaoSelecionadaId]="formImportacao.get('conexaoId')?.value"
                (conexaoSelecionada)="onConexaoSelecionada($event)">
              </app-seletor-conexao>
              <small class="p-error" *ngIf="campoInvalido('conexaoId', 0)">Conexão é obrigatória.</small>
            </div>

            <!-- Campos específicos por tipo -->
            <div class="field col-12" *ngIf="formImportacao.get('tipoComando')?.value === 'DATABASE_SQL' && formImportacao.get('conexaoId')?.value">
              <p-floatLabel>
                <textarea 
                  pInputTextarea 
                  id="comando" 
                  formControlName="comando" 
                  rows="8"
                  [class.ng-invalid]="campoInvalido('comando', 0)">
                </textarea>
                <label for="comando">Comando SQL (SELECT) *</label>
              </p-floatLabel>
              <small class="p-error" *ngIf="campoInvalido('comando', 0)">O comando SQL é obrigatório.</small>
            </div>

            <div class="field col-12 md:col-6" *ngIf="formImportacao.get('tipoComando')?.value === 'API_ENDPOINT' && formImportacao.get('conexaoId')?.value">
              <app-seletor-endpoint 
                [conexaoId]="formImportacao.get('conexaoId')?.value" 
                [endpointSelecionadoId]="formImportacao.get('endpointId')?.value"
                (endpointSelecionado)="onEndpointSelecionado($event)">
              </app-seletor-endpoint>
              <small class="p-error" *ngIf="campoInvalido('endpointId', 0)">O endpoint é obrigatório.</small>
            </div>

            <div class="field col-12">
              <p-floatLabel>
                <p-chips id="camposChave" formControlName="camposChave" separator=","></p-chips>
                <label for="camposChave">Campos Chave (Ex: ID, CODIGO. Pressione Enter ou use vírgula)</label>
              </p-floatLabel>
              <small class="text-secondary">Defina quais campos identificam univocamente o registro.</small>
            </div>
          </div>
        </form>
      </p-panel>
    </div>

    <!-- Passo 2: Processamento -->
    <div *ngIf="activeIndex === 1">
      <p-panel header="Passo 2: Configurar Recurso de Processamento">
        <form [formGroup]="formProcessamento">
          <div class="grid p-fluid mt-2">
            <div class="col-12">
              <h5 class="border-bottom-1 surface-border pb-2">Dados do Recurso</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeRecursoProc" formControlName="nomeRecurso" [class.ng-invalid]="campoInvalido('nomeRecurso', 1)" />
                <label for="nomeRecursoProc">Nome do Recurso *</label>
              </p-floatLabel>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="descricaoRecursoProc" formControlName="descricaoRecurso" />
                <label for="descricaoRecursoProc">Descrição do Recurso</label>
              </p-floatLabel>
            </div>

            <div class="col-12 mt-3">
              <h5 class="border-bottom-1 surface-border pb-2">Configuração do Mapeamento de Transformação</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeMapeamentoProc" formControlName="nomeMapeamento" [class.ng-invalid]="campoInvalido('nomeMapeamento', 1)" />
                <label for="nomeMapeamentoProc">Nome do Mapeamento *</label>
              </p-floatLabel>
            </div>
            
            <div class="col-12">
              <app-editor-mapeamento
                titulo="Transformação: Campo Origem -> Campo Destino"
                [mapeamentos]="formProcessamento.get('mapeamentos')?.value"
                [camposOrigem]="formImportacao.get('camposChave')?.value"
                (mapeamentosAlterados)="onMapeamentosAlterados($event, 1)">
              </app-editor-mapeamento>
              <small class="text-secondary">Os "Campos Origem" disponíveis são baseados nos campos chave definidos no Passo 1.</small>
            </div>
          </div>
        </form>
      </p-panel>
    </div>

    <!-- Passo 3: Visualização -->
    <div *ngIf="activeIndex === 2">
      <p-panel header="Passo 3: Configurar Recurso de Visualização">
        <form [formGroup]="formVisualizacao">
          <div class="grid p-fluid mt-2">
            <div class="col-12">
              <h5 class="border-bottom-1 surface-border pb-2">Dados do Recurso</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeRecursoVis" formControlName="nomeRecurso" [class.ng-invalid]="campoInvalido('nomeRecurso', 2)" />
                <label for="nomeRecursoVis">Nome do Recurso *</label>
              </p-floatLabel>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="descricaoRecursoVis" formControlName="descricaoRecurso" />
                <label for="descricaoRecursoVis">Descrição do Recurso</label>
              </p-floatLabel>
            </div>

            <div class="col-12 mt-3">
              <h5 class="border-bottom-1 surface-border pb-2">Configuração do Mapeamento para Interface (UI)</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeMapeamentoVis" formControlName="nomeMapeamento" [class.ng-invalid]="campoInvalido('nomeMapeamento', 2)" />
                <label for="nomeMapeamentoVis">Nome do Mapeamento *</label>
              </p-floatLabel>
            </div>
            
            <div class="col-12">
              <app-editor-mapeamento
                titulo="Visualização: Campo Processado -> Campo UI"
                [mapeamentos]="formVisualizacao.get('mapeamentos')?.value"
                [camposOrigem]="formImportacao.get('camposChave')?.value"
                (mapeamentosAlterados)="onMapeamentosAlterados($event, 2)">
              </app-editor-mapeamento>
            </div>
          </div>
        </form>
      </p-panel>
    </div>

    <!-- Passo 4: Exportação -->
    <div *ngIf="activeIndex === 3">
      <p-panel header="Passo 4: Configurar Recurso de Exportação">
        <form [formGroup]="formExportacao">
          <div class="grid p-fluid mt-2">
            <div class="col-12">
              <h5 class="border-bottom-1 surface-border pb-2">Dados do Recurso</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeRecursoExp" formControlName="nomeRecurso" [class.ng-invalid]="campoInvalido('nomeRecurso', 3)" />
                <label for="nomeRecursoExp">Nome do Recurso *</label>
              </p-floatLabel>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="descricaoRecursoExp" formControlName="descricaoRecurso" />
                <label for="descricaoRecursoExp">Descrição do Recurso</label>
              </p-floatLabel>
            </div>

            <div class="col-12 mt-3">
              <h5 class="border-bottom-1 surface-border pb-2">Configuração do Comando de Exportação (Destino)</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeComandoExp" formControlName="nomeComando" [class.ng-invalid]="campoInvalido('nomeComando', 3)" />
                <label for="nomeComandoExp">Nome do Comando *</label>
              </p-floatLabel>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <p-dropdown id="tipoComandoExp" [options]="tiposComando" formControlName="tipoComando" appendTo="body"></p-dropdown>
                <label for="tipoComandoExp">Tipo de Comando *</label>
              </p-floatLabel>
            </div>

            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <p-dropdown 
                  id="provedorIdExp" 
                  [options]="formExportacao.get('tipoComando')?.value === 'DATABASE_SQL' ? provedoresBD : provedoresAPI" 
                  optionLabel="nome" 
                  optionValue="id" 
                  formControlName="provedorId" 
                  [filter]="true" 
                  placeholder="Selecione o Provedor"
                  appendTo="body">
                </p-dropdown>
                <label for="provedorIdExp">Provedor de Destino *</label>
              </p-floatLabel>
            </div>

            <div class="field col-12 md:col-6" *ngIf="formExportacao.get('provedorId')?.value">
              <app-seletor-conexao 
                [provedorId]="formExportacao.get('provedorId')?.value" 
                [conexaoSelecionadaId]="formExportacao.get('conexaoId')?.value"
                (conexaoSelecionada)="formExportacao.patchValue({ conexaoId: $event.id })">
              </app-seletor-conexao>
            </div>

            <div class="field col-12 md:col-6" *ngIf="formExportacao.get('tipoComando')?.value === 'API_ENDPOINT' && formExportacao.get('conexaoId')?.value">
              <app-seletor-endpoint 
                [conexaoId]="formExportacao.get('conexaoId')?.value" 
                [endpointSelecionadoId]="formExportacao.get('endpointId')?.value"
                (endpointSelecionado)="formExportacao.patchValue({ endpointId: $event.id })">
              </app-seletor-endpoint>
            </div>
          </div>
        </form>
      </p-panel>
    </div>

    <!-- Passo 5: Publicação -->
    <div *ngIf="activeIndex === 4">
      <p-panel header="Passo 5: Configurar Recurso de Publicação (Opcional)">
        <form [formGroup]="formPublicacao">
          <div class="grid p-fluid mt-2">
            <div class="col-12">
              <h5 class="border-bottom-1 surface-border pb-2">Dados da Publicação</h5>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="nomeRecursoPub" formControlName="nomeRecurso" [class.ng-invalid]="campoInvalido('nomeRecurso', 4)" />
                <label for="nomeRecursoPub">Nome da Publicação *</label>
              </p-floatLabel>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <input pInputText id="codigoPub" formControlName="codigo" [class.ng-invalid]="campoInvalido('codigo', 4)" />
                <label for="codigoPub">Código do Endpoint (slug) *</label>
              </p-floatLabel>
              <small class="text-secondary">Será usado na URL: /publicacao/&#123;&#123;formPublicacao.get('codigo')?.value || 'meu-slug'&#125;&#125;</small>
            </div>
            <div class="field col-12 md:col-6">
              <p-floatLabel>
                <p-dropdown id="direcaoPub" [options]="[{label: 'Outbound (API Pública)', value: 'OUTBOUND'}, {label: 'Inbound (Webhook)', value: 'INBOUND'}]" formControlName="direcao" appendTo="body"></p-dropdown>
                <label for="direcaoPub">Direção *</label>
              </p-floatLabel>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>

  <!-- Botões de Navegação -->
  <div class="flex justify-content-between mt-4 pt-4 border-top-1 surface-border">
    <p-button
      label="Voltar"
      icon="pi pi-arrow-left"
      severity="secondary"
      (click)="voltar()">
    </p-button>

    <div>
      <p-button
        label="Anterior"
        icon="pi pi-angle-left"
        (onClick)="prevStep()"
        [disabled]="activeIndex === 0">
      </p-button>
      <p-button
        *ngIf="activeIndex < steps.length - 1"
        label="Próximo"
        icon="pi pi-angle-right"
        iconPos="right"
        (onClick)="nextStep()"
        styleClass="ml-2">
      </p-button>
      <p-button
        *ngIf="activeIndex === steps.length - 1"
        label="Salvar"
        icon="pi pi-check"
        (onClick)="salvarWizard()"
        styleClass="p-button-success ml-2">
      </p-button>
    </div>
  </div>
</div>
